import React from "react"

const SaveIcon = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
    >
      <path
        d="M7.558 3.75H7.25C6.32174 3.75 5.4315 4.11875 4.77513 4.77513C4.11875 5.4315 3.75 6.32174 3.75 7.25V17.077C3.75 17.9185 4.0843 18.7256 4.67935 19.3207C5.2744 19.9157 6.08147 20.25 6.923 20.25M7.558 3.75V6.192C7.558 6.72243 7.76871 7.23114 8.14379 7.60621C8.51886 7.98129 9.02757 8.192 9.558 8.192H11.904C12.4344 8.192 12.9431 7.98129 13.3182 7.60621C13.6933 7.23114 13.904 6.72243 13.904 6.192V3.75M7.558 3.75H13.904M6.923 20.25V15C6.923 14.2044 7.23907 13.4413 7.80168 12.8787C8.36429 12.3161 9.12735 12 9.923 12H14.077C14.8726 12 15.6357 12.3161 16.1983 12.8787C16.7609 13.4413 17.077 14.2044 17.077 15V20.25M6.923 20.25H17.077M13.904 3.75H13.93C14.3241 3.74995 14.7144 3.82756 15.0785 3.97838C15.4426 4.1292 15.7734 4.35029 16.052 4.629L19.225 7.802C19.55 8.12703 19.8078 8.51289 19.9837 8.93755C20.1595 9.36222 20.25 9.81736 20.25 10.277V17.077C20.25 17.9185 19.9157 18.7256 19.3207 19.3207C18.7256 19.9157 17.9185 20.25 17.077 20.25"
        stroke="black"
        strokeWidth="1.3"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M7.558 3.75H7.25C6.32174 3.75 5.4315 4.11875 4.77513 4.77513C4.11875 5.4315 3.75 6.32174 3.75 7.25V17.077C3.75 17.9185 4.0843 18.7256 4.67935 19.3207C5.2744 19.9157 6.08147 20.25 6.923 20.25M7.558 3.75V6.192C7.558 6.72243 7.76871 7.23114 8.14379 7.60621C8.51886 7.98129 9.02757 8.192 9.558 8.192H11.904C12.4344 8.192 12.9431 7.98129 13.3182 7.60621C13.6933 7.23114 13.904 6.72243 13.904 6.192V3.75M7.558 3.75H13.904M6.923 20.25V15C6.923 14.2044 7.23907 13.4413 7.80168 12.8787C8.36429 12.3161 9.12735 12 9.923 12H14.077C14.8726 12 15.6357 12.3161 16.1983 12.8787C16.7609 13.4413 17.077 14.2044 17.077 15V20.25M6.923 20.25H17.077M13.904 3.75H13.93C14.3241 3.74995 14.7144 3.82756 15.0785 3.97838C15.4426 4.1292 15.7734 4.35029 16.052 4.629L19.225 7.802C19.55 8.12703 19.8078 8.51289 19.9837 8.93755C20.1595 9.36222 20.25 9.81736 20.25 10.277V17.077C20.25 17.9185 19.9157 18.7256 19.3207 19.3207C18.7256 19.9157 17.9185 20.25 17.077 20.25"
        stroke="#1C1F21"
        strokeWidth="1.3"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  )
}

export default SaveIcon
